import React from 'react'
import { injectIntl } from 'react-intl'

import Button from '@uniiverse/library/components/button'
import SearchIcon from '@uniiverse/library/assets/icons/new-search.svg'

import { TextInput } from '../text-input/index'
import { LocationInput } from '../location-input/index'

import style from './index.css'

import locale from './locale'

class SearchInputsComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lat: props.lat,
      lon: props.lon,
      searchQuery: props.searchQuery,
      locationQuery: this.props.locationQuery,
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.locationQuery && this.props.locationQuery) {
      this.setState({ locationQuery: this.props.locationQuery })
    }
  }

  onSubmit = (e) => {
    e.preventDefault()
  }

  changeSearchQuery = (e) => {
    this.setState({ searchQuery: e.target.value })
  }

  changeLocation = ({ lat, lon, locationQuery }) => {
    this.setState({ lat, lon, locationQuery })
  }

  changeLocationQuery = (locationQuery) => {
    this.setState({ locationQuery })
  }

  search = () => {
    const { searchParams } = new URL(window.location)
    searchParams.set('query', encodeURIComponent(this.state.searchQuery))
    searchParams.set('loc', encodeURIComponent(this.state.locationQuery))
    searchParams.set('ll', encodeURIComponent(`${this.state.lat},${this.state.lon}`))
    const url = `/explore?${searchParams.toString()}`
    this.props.history.push(url)
    if (this.props.onSearch) this.props.onSearch()
  }

  render() {
    const {
      intl: { formatMessage },
      searchText,
      withSearchIcon,
      className = '',
      queryClassName = '',
      locationClassName = '',
      buttonClassName = '',
    } = this.props

    return (
      <form action="#" onSubmit={this.onSubmit}>
        <div className={`${style.container} ${className}`}>
          <TextInput
            className={`${style.searchInputContainer} ${queryClassName}`}
            icon={withSearchIcon && <SearchIcon className={style.searchIcon} />}
            inputProps={{
              onChange: this.changeSearchQuery,
              value: this.state.searchQuery,
              placeholder: formatMessage(locale.searchPlaceholder),
              className: style.searchInput,
              page: this.props.page,
            }}
            withClearIcon
          />
          <LocationInput
            className={`${style.locationInputContainer} ${locationClassName}`}
            inputClassName={style.locationInput}
            value={this.state.locationQuery}
            onChange={this.changeLocationQuery}
            changeLocation={this.changeLocation}
          />
          <Button
            type="primary"
            className={`${style.searchButton} ${buttonClassName}`}
            onClick={this.search}
            disabled={!this.state.locationQuery}
          >
            {searchText}
          </Button>
        </div>
      </form>
    )
  }
}

export const SearchInputs = injectIntl(SearchInputsComponent)
